"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrewRole = void 0;
var CrewRole;
(function (CrewRole) {
    CrewRole["DIRECTOR"] = "director";
    CrewRole["CO_DIRECTOR"] = "co-director";
    CrewRole["PRODUCER"] = "producer";
    CrewRole["EXECUTIVE_PRODUCER"] = "executive-producer";
    CrewRole["CO_PRODUCER"] = "co-producer";
    CrewRole["ASSOCIATE_PRODUCER"] = "associate-producer";
    CrewRole["COLLABORATING_DIRECTOR"] = "collaborating-director";
    CrewRole["PRODUCTION_MANAGER"] = "production-manager";
    CrewRole["PRODUCTION_COORDINATOR"] = "production-coordinator";
    CrewRole["PRODUCTION_ASSISTANT"] = "production-assistant";
    CrewRole["ASSISTANT_DIRECTOR"] = "assistant-director";
    CrewRole["2ND_ASSISTANT_DIRECTOR"] = "2nd-assistant-director";
    CrewRole["SCRIPT_SUPERVISOR"] = "script-supervisor";
    CrewRole["LOCATION_MANAGER"] = "location-manager";
    CrewRole["WRITER"] = "writer";
    CrewRole["CO_WRITER"] = "co-writer";
    CrewRole["STORY"] = "story";
    CrewRole["ADAPTATION"] = "adaptation";
    CrewRole["AUTHOR_OF_ADAPTED_MATERIAL"] = "author-of-adapted-material";
    CrewRole["CINEMATOGRAPHER_DP"] = "cinematographer-dp";
    CrewRole["ASSISTANT_CAMERA"] = "assistant-camera";
    CrewRole["ADDITIONAL_PHOTOGRAPHY"] = "additional-photography";
    CrewRole["2ND_UNIT_DIR_OF_PHOTOGRAPHY"] = "2nd-unit-dir-of-photography";
    CrewRole["CAMERA_OPERATOR"] = "camera-operator";
    CrewRole["GAFFER"] = "gaffer";
    CrewRole["BEST_BOY"] = "best-boy";
    CrewRole["KEY_GRIP"] = "key-grip";
    CrewRole["ADDITIONAL_GRIP"] = "additional-grip";
    CrewRole["DOLLY_GRIP"] = "dolly-grip";
    CrewRole["GRIP"] = "grip";
    CrewRole["SOUND_MIXER"] = "sound-mixer";
    CrewRole["BOOM_OPERATOR"] = "boom-operator";
    CrewRole["CABLE_PERSON"] = "cable-person";
    CrewRole["VIDEO_OPERATOR"] = "video-operator";
    CrewRole["ART_DIRECTOR"] = "art-director";
    CrewRole["ASSISTANT_ART_DIRECTOR"] = "assistant-art-director";
    CrewRole["COSTUME_DESIGNER"] = "costume-designer";
    CrewRole["COSTUMER"] = "costumer";
    CrewRole["HAIRSTYLIST"] = "hairstylist";
    CrewRole["LEAD_PERSON"] = "lead-person";
    CrewRole["MAKEUP_ARTIST"] = "makeup-artist";
    CrewRole["MAKEUP_EFFECTS"] = "makeup-effects";
    CrewRole["PRODUCTION_DESIGNER"] = "production-designer";
    CrewRole["PROPERTY_MASTER"] = "property-master";
    CrewRole["SET_DECORATOR"] = "set-decorator";
    CrewRole["SET_DESIGNER"] = "set-designer";
    CrewRole["SWING_GANG"] = "swing-gang";
    CrewRole["ANIMAL_TRAINER"] = "animal-trainer";
    CrewRole["CHOREOGRAPHER"] = "choreographer";
    CrewRole["SPECIAL_EFFECTS"] = "special-effects";
    CrewRole["STUNT_COORDINATOR"] = "stunt-coordinator";
    CrewRole["TECHNICAL_ADVISOR"] = "technical-advisor";
    CrewRole["EDITOR"] = "editor";
    CrewRole["ASSISTANT_EDITOR"] = "assistant-editor";
    CrewRole["SOUND_EDITOR"] = "sound-editor";
    CrewRole["DIGITAL_EFFECTS"] = "digital-effects";
    CrewRole["ORIGINAL_MUSIC_COMPOSER"] = "original-music-composer";
    CrewRole["ANIMATOR"] = "animator";
    CrewRole["AGENT"] = "agent";
    CrewRole["MANAGER"] = "manager";
    CrewRole["PUBLICIST"] = "publicist";
    CrewRole["PRINT_SHIPPER"] = "print-shipper";
    CrewRole["PRINT_RETURN"] = "print-return";
    CrewRole["PREVIEW_RETURN"] = "preview-return";
    CrewRole["ACADEMIC_ADVISOR"] = "academic-advisor";
    CrewRole["SCHOOL_ADMINISTRATOR"] = "school-administrator";
})(CrewRole = exports.CrewRole || (exports.CrewRole = {}));
//# sourceMappingURL=crew-role.js.map